import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    SeeProducts, SeeProductsByWinery, createProduct, deleteProduct, updateProduct
} from '../../actions/productActions'
import { seeListColorsReactions } from '../../actions/colorsActions'
import {
    seeWineries
} from '../../actions/wineryActions'
import { Field, Form, Formik } from 'formik';
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';
import { SeeCategories } from '../../actions/pCategoriesActions';
import { SeeSubCategories } from '../../actions/subCategoriesActions';
import { useTokenCallback } from '../../../utils/hooks/useTokenCallback';
import useModal from '../../../utils/hooks/useModal';

const ReactionAdmin = ({ }) => {
    const dispatch = useDispatch()
    const { isLoadingListColorsReaction, listColorsReaction } = useSelector(state => state.colorsReactionAdmin)

    const [imgSrc, setImgSrc] = useState("")
    const [wineryId, setWineryId] = useState("")
    useTokenCallback(() => {
        dispatch(seeListColorsReactions());
        dispatch(seeWineries())
        dispatch(SeeCategories())
        dispatch(SeeSubCategories())
    }, [])
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            console.log();
            if (wineryId === "") {
                dispatch(SeeProducts())
            } else {
                dispatch(SeeProductsByWinery(wineryId))
            }

        })

    }, [wineryId])
    const [isEidit, setIsEidit] = useState(false);
    const [id, setId] = useState()
    const [refDelete, isShowDelete, setIsShowDelete] = useModal(false)
    const formRef = useRef(null)
    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className="container-inputs-new-mark">
                    <div className="container-inputs-new-mark">
                        <Formik
                            onSubmit={(values) => {
                                const formData = new FormData();
                                for (var key in values) {
                                    if (key === "image" && values[key] === "") {

                                    } else {
                                        formData.append(key, values[key]);
                                    }
                                }
                                if (isEidit) {
                                    dispatch(updateProduct(formData, id,formRef))

                                } else {
                                    dispatch(createProduct(formData,formRef))
                                }
                            }}
                            onReset={() => {
                                setIsEidit(false);
                                setId(null);
                                setImgSrc("");
                            }}
                            initialValues={{
                                code: "",
                                categoryId: "",
                                subcategoryId: "",
                                name: '',
                                description: "",
                            }}
                            innerRef={formRef}>
                            {(props) => (
                                <Form>
                                    <label className="picture-register-mark">
                                        {imgSrc && <img className="img-100-center" src={imgSrc}></img>}
                                        <input accept='image/*' type="file" name="image"
                                            onChange={(event) => {
                                                setImgSrc(URL.createObjectURL(event.target.files[0]))
                                                props.setFieldValue("image", event.target.files[0])
                                            }}
                                        />
                                    </label>
                                    <div className="text-input-admin">
                                        Codigo
                                    </div>
                                    <Field className='inputs-admin' name="code" />
                                    <div className="text-input-admin">
                                        Nombre
                                    </div>
                                    <Field className='inputs-admin' name="name" />
                                    <div className="text-input-admin">
                                        Descripcion
                                    </div>
                                    <Field className='inputs-admin' name="description" />

                                    <div className="content-buttom-create">
                                        <button type='submit' className={`btns-admin btn-create-edit btns-admin-inactive`}>{isEidit ? Translate('edit', 'es') : Translate('create', 'es')}</button>
                                    </div>
                                </Form>)}
                        </Formik>
                    </div>
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>
                    Productos existente
                </div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListColorsReaction ? <div>Cargando...</div> :
                        listColorsReaction.map((reaction, index) => (
                            <div key={index} className="card-admin">
                                <img className="img-card-admin" src={reaction.icon?.url?.origin}></img>
                                <div className="tittle-card-admin">{reaction.name}</div>
                                <div ref={refDelete} className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setIsEidit(true)
                                        setId(reaction._id)
                                        setImgSrc(reaction.icon?.url?.origin)
                                        formRef.current.setFieldValue('image', "")
                                        formRef.current.setFieldValue('code', reaction.code)
                                        formRef.current.setFieldValue('name', reaction.name)
                                        formRef.current.setFieldValue('description', reaction.description)
                                    }}>Editar</div>
                                    <div className="btn-red btns-admin ml-1" onClick={() => setIsShowDelete(true)}>Eliminar</div>
                                    <Modal formRef={formRef} product={reaction} displayModal={isShowDelete} closeModal={() => { setIsShowDelete(false) }} />
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const Modal = ({ closeModal, displayModal, product,formRef }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        closeModal(e)
    }
    const ref = useRef(null)
    const dispatch = useDispatch();
    return <div
        className={"modal"}
        style={divStyle}
        ref={ref}
        onClick={close}>
        <div
            className="modal-content modal-content-new-post"
            onClick={e => e.stopPropagation()} >
            <Formik
                onSubmit={(values) => {
                    ref.current.click()
                    dispatch(deleteProduct(product._id,values.reasonForDeletion)).then(()=>{
                        formRef.current.resetForm()
                    })
                }}
                initialValues={{ reasonForDeletion: "" }}>
                {() => (
                    <Form>
                        <div className="text-input-admin">
                            Introduzca la razon que el producto: {product.name} sea eliminado
                        </div>
                        <Field className='inputs-admin' name="reasonForDeletion" />
                        <div className="content-buttom-create">
                            <button type='button' onClick={(e)=>{closeModal(e)}} className={`btns-admin btn-create-edit btns-admin-inactive`}>{Translate('cancel', 'es')}</button>
                            <button type='submit' className={`btns-admin btn-create-edit btns-admin-inactive`}>{Translate('create', 'es')}</button>
                        </div>
                    </Form>)}

            </Formik>
        </div>
    </div>
}
export default ReactionAdmin